import { CoachingPlanEligibilityDetails, CoachingPlanMatchMeta } from 'js/api/coaching-plan';

export const CoachingPlanCopies = {
  Heading: (details: CoachingPlanEligibilityDetails) =>
    `The ${details.plural} we’ve talked to often have specific needs, so we made a plan for you.`,
  MatchSummary: (matches: CoachingPlanMatchMeta[]) => matches.map(m => m.display_name).join(', '),
};
